import React from 'react';
import styles from './styles.module.scss';
import Text from 'components/typografy/text';
import {toTitleCase} from 'helpers';

const DialogContent: React.FC<{data: any}> = ({data}) => {

  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
            Reward Details
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
            Game
        </Text>
        <Text variant={'large'}>
          {toTitleCase(data.game_name)}
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
            Name
        </Text>
        <Text variant={'large'}>
          {toTitleCase(data.reward_name)}
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Earned
        </Text>
        <Text variant={'large'}>
          {data.event_value_str}
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Completed At
        </Text>
        <Text variant={'large'}>
          {data.event_time}
        </Text>
      </div>
      <div className={styles.row}>
        <Text variant={'large'} nativeClassname={styles.colorWhite}>
          Status
        </Text>
        <Text variant={'large'}>
          {toTitleCase(data.status)}
        </Text>
      </div>
    </div>
  );
};

export default DialogContent;
